var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default",null,null,{ active: _vm.active, toggle: _vm.toggle }),_vm._v(" "),_vm._t("content",null,null,{ active: _vm.active })],2)}
var staticRenderFns = []

export { render, staticRenderFns }